export { default } from './SpotMarker';
